import * as React from 'react'

/**
 * One cell of the dashboard banner.
 *
 * The banner is a single bordered card split by dividers rather than three
 * separate cards, so these render their own chrome — an uppercase eyebrow
 * label instead of a card title — and leave the border, rounding and
 * dividers to DashboardBanner.
 */
export default function BannerSection({
  label,
  right,
  className = '',
  children,
}: {
  label: React.ReactNode
  right?: React.ReactNode
  className?: string
  children: React.ReactNode
}) {
  return (
    <div className={`flex h-full flex-col gap-1.5 p-4 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-[10.5px] font-semibold uppercase tracking-wider text-txt-secondary">
          {label}
        </span>
        {right}
      </div>
      {children}
    </div>
  )
}
